import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { HttpService } from './http.service';
import { map, StorageUtil } from '../models';

const eventColors = [
  '#ff00c9', '#ff8b00', '#FFBF00', '#FF7F50', '#DE3163', '#9FE2BF', '#40E0D0', '#6495ED', '#CCCCFF',
  'FFFF00', '808000', '00FF00', '008000', '00FFFF', '008080', '0000FF', '000080'
];

@Injectable()
export class ClubSchedulerService {


  private _api = '/api/clubscheduler';

  constructor(
    private http: HttpClient,
    private httpService: HttpService
  ) { }

  //Scheduler Section
  getClubSchedulerComplexesAndVenuesByID(clubID: number) {
    return this.httpService.get(`${this._api}/get-club-scheduler-complexes-and-venues/${clubID}`);
  }
  //END Scheduler Section

  getClubSchedulerEventList(clubId: number, matchDate: string) {
    return this.httpService.get(`${this._api}/get-club-scheduler-left-event-list/${clubId}/${matchDate}`)
      .pipe(map(res => res.map((d, index) => ({
        ...d,
        eventColor: eventColors[index],
      }))));
  }

  getClubScheduledGamesList(clubId: number, matchDate: string) {
    // return this.httpService.get(`${this._api}/get-club-scheduler-complete-data-list/${clubId}/${matchDate}`);
    return this.httpService.get(`${this._api}/get-club-scheduler-grouped-complete-data-list/${clubId}/${matchDate}`);
  }

  getClubScheduledGamesListByRange(clubId: number, startDate: string, endDate: string) {
    return this.httpService.get(`${this._api}/get-club-scheduler-complete-data-list/${clubId}/${startDate}/${endDate}`);
  }

  getClubSchedulerPracticeTeams(clubId: number, type: string, gender: string, status: string, eventColor: string) {

    const _payload = {
      ClubId: clubId,
      Type: type,
      Gender: gender,
      Status: status,
      EventColor: eventColor
    }

    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'responseType': 'text'
      })
    };

    console.log("getClubSchedulerPracticeTeams (payload)  ===   ", _payload);

    return this.httpService.post(`${this._api}/get-club-scheduler-practice-teams`, _payload, httpOptions);
  }

  addPracticeToClubScheduler(_apiPayload: any) {
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'responseType': 'text'
      })
    };

    console.log("_apiPayload (service) = ", _apiPayload);

    return this.httpService.post(`${this._api}/add-practice-to-club-scheduler`, _apiPayload, httpOptions);
  }


  unscheduleSelectedMatchByMatchId(Id: Object) {
    return this.httpService.post(`${this._api}/unschedule-selected-match-by-match-id/${Number(Id)}`);
  }

  unscheduleSelectedPracticeById(id: number, removeRepeat: number) {
    return this.httpService.post(`${this._api}/unschedule-selected-practice-by-practice-id/${StorageUtil.clubID}/${id}/${removeRepeat}`);
  }

  updateSelectedPracticeById(payload: any, updatedby: number, updateRepeat: number) {
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'responseType': 'text'
      }),
      params: {
        clubID: StorageUtil.clubID.toString()
      }
    };
    return this.http.post(`${this._api}/update-selected-practice-by-practice-id/${updatedby}/${updateRepeat}`, payload, httpOptions);
  }

  getClubSchedulerEventSchedulesGames(clubId: number, eventId: number, matchDate: string) {
    return this.httpService.get(`${this._api}/get-club-scheduler-event-schedules-games/${clubId}/${eventId}/${matchDate}`);
  }

  dragAndDropMatch(payload: any) {
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'responseType': 'text'
      })
    };
    return this.http.post(this._api + '/club-scheduler-drag-and-drop-a-match', payload, httpOptions);
  }

  updateScheduleGame(gameId: number, game: any) {
    var data = game;
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'responseType': 'text'
      })
    };
    return this.http.post(this._api + '/club-scheduler-update-schedule-game/' + gameId, data, httpOptions);
  }
  
  updateTeamHasAccessToAddPracticeByClubID(payload: any) {
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'responseType': 'text'
      })
    };
    return this.http.post(this._api + '/update-team-has-access-to-add-practice-by-clubID', payload, httpOptions);
  }

  getIsTeamHasAccessToAddPracticeByClubID(clubID: number) {
    return this.httpService.get(`${this._api}/get-is-team-has-access-to-add-practice-by-clubID/${clubID}`);
  }

  getClubMatches(clubID: number, startDate: string, endDate: string) {
    return this.httpService.get(`${this._api}/get-club-matches/${clubID}/${startDate}/${endDate}`)
  }

  getTeamScheduleMatches(teamID: number, startDate: string, endDate: string) {
    return this.httpService.get(`${this._api}/get-team-scheduler-matches/${teamID}/${startDate}/${endDate}`)
  }

  getClubEvents(clubID: number) {
    return this.httpService.get(`${this._api}/get-club-events/${clubID}`)
  }

  getClubPractices(clubID: number, startDate: string, endDate: string) {
    return this.httpService.get(`${this._api}/get-club-practices/${clubID}/${startDate}/${endDate}`);
  }

  getTeamSchedulePractices(teamID: number, startDate: string, endDate: string) {
    return this.httpService.get(`${this._api}/get-team-scheduler-practices/${teamID}/${startDate}/${endDate}`);
  }
}



// WEBPACK FOOTER //
// ./src/app/services/club-scheduler.service.ts.ts